var NamecardItemMixins;

import NamecardModal from 'trunks/vue/admin/compositions/organization_namecards/namecard_modal.js';

import {
  newConfirm
} from 'trunks/vue/admin/components/libs/confirm.js';

import {
  newAlertify
} from 'trunks/vue/admin/components/alert.js';

export default NamecardItemMixins = Vue.extend({
  methods: {
    deleteNamecard: function() {
      return newConfirm({
        icon: "<i class='slp-warning-circle-o'></i>",
        title: '确认删除此组织名片',
        confirmButtonText: '删除',
        cancelButtonText: '取消',
        type: 'danger'
      }).$on('ensureClicked', () => {
        return Skylark.Libs.Ajax.delete(`${this.resources}/${this.namecard.id}`, {
          contentType: 'application/json; charset=utf-8',
          responseType: 'json',
          success: () => {
            newAlertify('删除名片成功', {
              type: 'success'
            });
            return this.$emit('namecardDeleted', this.namecard);
          },
          error: function() {
            return newAlertify('删除失败', {
              type: 'error'
            });
          }
        });
      });
    },
    editNamecard: function() {
      return new NamecardModal({
        el: Skylark.Helpers.Utilities.getOrCreateCleaningElementByIdForVue('add-namecard'),
        propsData: {
          namecard: this.namecard,
          resources: this.resources,
          namecardCallback: (data) => {
            return this.$emit('namecardChanged', data);
          }
        }
      });
    }
  },
  computed: {
    picture: function() {
      return `background-image: url('${this.namecard.picture}')`;
    }
  }
});
